<!---
    /**
    * File and all contents are proprietary work of Executives On The Web Ltd
    * and must not be copied or redistributed without express permission.
    *
    * Creates a comments creating section
    *
    * @since 20200624
    * @author Thomas Higham <thomash@executivesontheweb.com>
    *
    * @copyright (c) 2020 Executives On The Web Ltd. All right Reserved.
    */
--->
<template>
    <div>
        <!-- Preview Comms modal -->
        <comms-preview-modal ref="previewModal"
            :id="'commentsPreviewModal' + the_id"
            @updateComm="updateComm"
        ></comms-preview-modal>

      <!-- Show all comments modal -->
        <div class="modal fade" :id="'history_modal_' + the_id" role="dialog">
            <div class="modal-dialog modal-lg">       
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">All {{commentName}}s</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body">
                        <div class="table-responsive">
                            <table class="table table-striped table-hover table-bordered customTable-md">
                                <thead>
                                    <tr class="table-info">
                                        <th>Date</th>
                                        <th v-if="!hideDoneBy">Done By</th>                                              
                                        <th>{{commentName}}</th> 
                                        <th>Actions&emsp;</th> 

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="com in orderedByDate" :key="com.id">
                                        <td data-th="Date:"><span data-toggle="popover" data-placement="top" data-trigger="hover" :data-content="formatdatetime(com.created_at)">{{formatdate(com.created_at)}}</span></td>
                                        <td data-th="Done By:"  v-if="!hideDoneBy"><span v-if="com.admin !== null">{{displayName(com.admin)}}</span><span v-else>-</span></td>
                                        <td data-th="Comment:">{{com.comments}}</td>
                                        <td data-th="Actions:">
                                            <button v-if="com.comm !== undefined" class="border-0 bg-transparent mt-1" 
                                                type="button" @click="showPreview(com.comm)"
                                                data-toggle="popover" data-placement="top" data-trigger="hover" data-content="Preview">
                                                <i class="fa fa-eye fa-lg text-secondary" aria-hidden="true"></i>
                                            </button> 
                                            <button v-if="com.deleting && com.can_delete" class="border-0 bg-transparent text-danger mt-1" 
                                                type="button" disabled data-toggle="popover" data-placement="top" data-trigger="hover" data-content="Delete Permanently">
                                                <i class="fa fa-trash pr-1" aria-hidden="true"></i>
                                                <span class="hidden-mobile">Deleting <i class="fas fa-sync fa-spin pl-1"></i></span>
                                            </button> 
                                            <button v-else-if="com.can_delete" class="border-0 bg-transparent mt-1" 
                                                type="button"  @click="delete_comment(com)" data-toggle="popover" 
                                                data-placement="top" data-trigger="hover" data-content="Delete Permanently">
                                                <i class="fa fa-trash fa-lg text-danger" aria-hidden="true"></i>
                                            </button> 
                                        </td>
                                    </tr>                                         
                                </tbody>
                            </table>
                        </div> 
                    </div>
                </div>
            </div>
        </div> <!--  END MODAL -->


        <!--  Comments -->                                                                                             
        <div class="row border-top  border-bottom py-3">		
            <div class="col-md-12">
                <div class="card h-100 shadow-sm">                 
                    <div class="card-header bg-white pb-0">
                        <div class="d-flex p-2 justify-content-between">
                            <label class="text-20 text-info">
                               <!--  {{commentName}}s -->
                                Company History<span class="badge badge-pill badge-info ml-2">{{commentsActual.length}}</span><!--show the number of all comments -->
                            </label>
                            
                            <div class="text-right" v-if="commentsActual.length >3">
                                <button type="button" class="btn btn-outline-info" @click="show_all_comments">Show All Activities</button>
                                <!-- Show 2 or 3 messages. On button click show/hide the rest of the comments -->
                            </div>
                            <!-- Button to Open the Modal -->
                            <button type="button" class="btn btn-success text-uppercase" @click="openCommentModal()" >
                            + Add Comment
                            </button>
                            
                        </div>
                    </div>
                        <div class="card-body p-0">
                        <div class="table-responsive mb-0">
                            <table class="table table-hover table-bordered table-sm customTable-md shadow">
                                <thead>
                                    <tr class="table-info">
                                        <th>Date</th>
                                        <th v-if="!hideDoneBy">Done By</th>                                              
                                        <th>Activities</th> 
                                        <th>Actions&emsp;</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="com in lastestComments" :key="com.id">
                                        <td data-th="Date:"><span data-toggle="popover" data-placement="top" data-trigger="hover" :data-content="formatdatetime(com.created_at)">{{formatdate(com.created_at)}}</span></td>
                                        <td data-th="Done By:" v-if="!hideDoneBy"><span v-if="com.admin !== null">{{displayName(com.admin)}}</span><span v-else>-</span></td>
                                        <td data-th="Comment:" class="text-truncate-3 border-bottom-0">{{com.comments}}</td>
                                        <td data-th="Actions:">
                                            <button v-if="com.comm !== undefined" class="border-0 bg-transparent mt-1" 
                                                type="button" @click="showPreview(com.comm)"
                                                data-toggle="popover" data-placement="top" data-trigger="hover" data-content="Preview">
                                                <i class="fa fa-eye fa-lg text-secondary" aria-hidden="true"></i>
                                            </button> 
                                            <button v-if="com.deleting && com.can_delete" class="border-0 bg-transparent text-danger mt-1" 
                                                type="button" disabled data-toggle="popover" data-placement="top" data-trigger="hover" data-content="Delete Permanently">
                                                <i class="fa fa-trash pr-1" aria-hidden="true"></i>
                                                <span class="hidden-mobile">Deleting <i class="fas fa-sync fa-spin pl-1"></i></span>
                                            </button> 
                                            <button v-else-if="com.can_delete" class="border-0 bg-transparent mt-1" 
                                                type="button"  @click="delete_comment(com)" data-toggle="popover" 
                                                data-placement="top" data-trigger="hover" data-content="Delete Permanently">
                                                <i class="fa fa-trash fa-lg text-danger" aria-hidden="true"></i>
                                            </button> 
                                            
                                        </td>
                                    </tr>                                       
                                </tbody>
                            </table>
                        </div>       
                    </div>
                </div>
            </div>
        </div><!-- END Comments -->

        <!-- The Modal -->
        <div class="modal fade" id="newCommentModal" role="dialog" > 
            <div class="modal-dialog">
                <div class="modal-content">
                    <!-- Modal Header -->
                    <div class="modal-header">
                        <h4 class="modal-title"><span v-if="viewComment==undefined||viewComment==''">Add New</span> {{commentName}}</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <!-- Modal body -->
                    <div class="modal-body" >
                        <div v-if="canAddComment" >                                               
                            <div v-if="viewComment==undefined || viewComment==''" class="form-group">
                                <label>Please Type Your {{commentName}} Below:</label>
                                <textarea class="form-control" name="comment" rows="4" v-model="comment"></textarea>             
                            </div>
                            <span v-else>{{viewComment}}</span>                           
                        </div>
                    </div>

                    <!-- Modal footer -->
                    <div class="modal-footer">
                        <span v-if="viewComment==undefined || viewComment==''">
                            <button v-if="saving" type="button" class="btn btn-primary" disabled>
                                <i class="fa fa-floppy-o fa-lg pr-1" aria-hidden="true"></i>Saving <i class="fas fa-sync fa-spin pl-1"></i></button>
                            <button v-else type="button" class="btn btn-primary" @click="save_comment">
                                <i class="fa fa-floppy-o fa-lg pr-1" aria-hidden="true"></i>Save</button>
                        </span>
                        <button type="button" class="btn btn-outline-danger" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    //stores a counter of ids so that each tooltip has a unique id for reference
    export const store = {
        state: 1,
        increment() {
            ++this.state
        }
    };
    export default{
        props: {
            //the array of comments
            history: {
                type: Array
            },
            //the route to store
            storeRoute: {
                type: String
            },
            //if they can add comments
            canAddComment: {
                type: Boolean
            },
            //if done by should be hidden
            hideDoneBy: {
                type: Boolean,
                default: false
            },
            commentName: {
                type: String,
                default: 'Comment'
            }
        },
        mounted() {
            this.the_id = store.state;
            store.increment();
            var self = this;
            //add in a check to alert the user that a comment hasn't been saved if they leave it in the box without saving
            window.addEventListener("beforeunload", function (e) {
                if (self.comment === undefined || self.comment === null || self.comment.length == 0) {
                    return undefined;
                }
                
                //custom messages don't work in most modern browswers, but left it in just in case.
                var confirmationMessage = 'It looks like you have been adding in a comment. ';
                if(self.saving){
                    confirmationMessage = confirmationMessage + ' It is still saving, please wait for it to finish saving before leaving the page.';
                } else {
                    confirmationMessage = confirmationMessage + ' If you do not save the comment before leaving the page, it will be lost.';
                }

                (e || window.event).returnValue = confirmationMessage; //Gecko + IE
                return confirmationMessage; //Gecko + Webkit, Safari, Chrome etc.
            });
        },
        data() {
            return {
                // the array of comments
                commentsActual: this.history,
                comment: '',
                saving: false,
                error_occured: false,
                // the unique id
                the_id: 1,
                viewComment:''           
            }
        },
        computed: {
            orderedByDate: function(){
                var currArr = [];
                for(var i=0; i<this.commentsActual.length; i++){
                    var visitDate = new Date(this.commentsActual[i].created_at);
                    var arrInd = 0;
                    for(var j=0; j<currArr.length; j++){
                        var date = new Date(currArr[j].created_at);
                        if(date > visitDate){
                            arrInd = j+1;
                        }
                    }
                    if(arrInd <= 0){
                        currArr.unshift(this.commentsActual[i]);
                    } else if(arrInd >= currArr.length){
                        currArr.push(this.commentsActual[i]);
                    } else {
                        currArr.splice(arrInd, 0, this.commentsActual[i]);
                    }
                }
                return currArr; 
            },
            lastestComments: function(){
                var arr = [];
                for(var i=0; i<this.orderedByDate.length; i++){
                    if(i < 3){
                        arr.push(this.orderedByDate[i]);
                    }
                }
                return arr;
            }
        },
        methods: {
            showPreview: function(comm) {
                this.$refs.previewModal.showPreviewModal({
                    'comms': [comm]
                });
                $('#history_modal_' + this.the_id).modal('hide');
            },

            openCommentModal: function() {  
               this. viewComment='';                       
                $('#newCommentModal').modal('show'); 
            },

            updateComm: function(comm){
                var arr = [];
                for(var i=0; i<this.commentsActual.length; i++){
                    if(this.commentsActual[i].comm !== undefined && this.commentsActual[i].comm.id == comm.id){
                        this.commentsActual[i].comm = comm;
                        arr.push(this.commentsActual[i]);
                    } else {
                        arr.push(this.commentsActual[i]);
                    }
                }
                this.commentsActual = arr;
            },
            push_comment: function(comm){
                var self = this;
                self.commentsActual.unshift(comm);
            },
           /**
             * saves the comments
             */
            async save_comment (){
                if(this.comment == '' || this.comment === undefined || this.comment === null){
                    alert('Please enter a comment');
                } else {
                    this.saving = true;
                    console.log('savingR: ' + this.storeRoute);
                    this.error_occured = false;
                    var self = this;
                    const data = await this.$http.post( this.storeRoute, { comment: this.comment })
                    .then(function (response) {
                        if(!self.error_occured){
                            if(response.data.error !== undefined){
                                self.error_occured = true;
                                console.log('An error occurred adding the comment');
                                console.log(response.data.error);
                            } else {
                                console.log(response.data);
                                self.commentsActual.unshift(response.data);
                                self.$parent.$parent.$refs.comments.push_comment(response.data);                                                    
                            }
                        } else {
                            self.error_occured = true;
                        }
                    }).catch((error) => {
                        self.error_occured = true;                        
                        console.log('An error occurred adding the comment');
                        if(error.response !== undefined){
                            console.log('File: ' + error.response.data.file);
                            console.log('Line: ' + error.response.data.line);
                            console.log('Message: ' + error.response.data.message);
                            console.log('Exception: ' + error.response.data.exception);
                            console.log(error.response.data.trace);
                        } else {
                            console.log(error);
                        }
                    }).finally(function () {
                        self.comment = '';
                        self.saving = false;
                        $('#newCommentModal').modal('hide');
                    });
                }
            },
            /**
             * deletes the comment
             * @param comment the comment to delete
             */
            async delete_comment (comment){
                if(confirm('Are you sure that you want to permanently delete this comment?')){
                    this.error_occured = false;
                    var self = this;
                    comment.deleting = true;
                    const  data  = await this.$http.delete(
                        comment.delete_route,
                        { }
                    ).then(function (response) {
                        if(!self.error_occured){
                            if(response.data.error !== undefined){
                                self.error_occured = true;
                                console.log('An error occurred deleting the comment');
                                console.log(response.data.error);
                            } else {
                                console.log(response.data);
                                var arr = [];
                                for(var i=0; i<self.commentsActual.length; i++){
                                    if(self.commentsActual[i].id != comment.id){
                                        arr.push(self.commentsActual[i]);
                                    }
                                }
                                console.log(self.$parent.$parent);
                                self.commentsActual = arr;
                                self.$parent.$parent.$refs.comments.delete_success(comment);
                            }
                        } else {
                            self.error_occured = true;
                        }
                    }).catch((error) => {
                        self.error_occured = true;
                        
                        console.log('An error occurred deleting the comment');
                        if(error.response !== undefined){
                            console.log('File: ' + error.response.data.file);
                            console.log('Line: ' + error.response.data.line);
                            console.log('Message: ' + error.response.data.message);
                            console.log('Exception: ' + error.response.data.exception);
                            console.log(error.response.data.trace);
                        } else {
                            console.log(error);
                        }
                    }).then(function () {
                        comment.deleting = false;
                    });
                }
            },
            delete_success: function(comment) {
                var arr= [];
                var self = this;
                for(var i=0; i<self.commentsActual.length; i++){
                    if(self.commentsActual[i].id != comment.id){
                        arr.push(self.commentsActual[i]);
                    }
                }
                self.commentsActual = arr;
            },
            /**
             * shows the all comments modal
             */
            show_all_comments: function(){
                $('#history_modal_' + this.the_id).modal('show');
            },
            /**
             * get display name for given contact
             */
            displayName: function(contact, show_last_name = true) {
                let name = '';
                if (contact.preferred_name !== "undefined" && contact.preferred_name && contact.preferred_name.length) {
                    name = contact.preferred_name;
                } else if (contact.first_name !== "undefined"  && contact.first_name && contact.first_name.length) {
                    name = contact.first_name;
                }

                if (show_last_name && contact.last_name !== "undefined" && contact.last_name && contact.last_name.length) {
                    name += ' ' + contact.last_name;
                }

                return name;
            },
                       /**
             * formats a date for displaying
             * 
             * @param Date dt the date to display
             * @returns String the formatted date
             */
             formatdate: function (dt){
                var date = new Date(dt);
                var day = date.getDate() + '';
                if(day.length == 1){
                    var day = '0' + day;
                }
                var month = (date.getMonth()+1) + '';
                if(month.length == 1){
                    var month = '0' + month;
                }
                return day + '/' + month + '/' + date.getFullYear();
            },
            /**
             * formats a date for displaying
             * 
             * @param Date dt the date to display
             * @returns String the formatted date
             */
            formatdatetime: function (dt){
                var date = new Date(dt);
                var day = date.getDate() + '';
                if(day.length == 1){
                    var day = '0' + day;
                }
                var month = (date.getMonth()+1) + '';
                if(month.length == 1){
                    var month = '0' + month;
                }
                var hour = (date.getHours()) + '';
                if(hour.length == 1){
                    var hour = '0' + hour;
                }
                var minute = (date.getMinutes()) + '';
                if(minute.length == 1){
                    var minute = '0' + minute;
                }
                return day + '/' + month + '/' + date.getFullYear() + ' ' + hour + ':' + minute;
            },
        }
    }
</script>